<template>
  <div @touchmove.prevent>
    <div :class="$style.box">
      <div :class="$style.content">
        <div></div>
        <div></div>
        <div :class="$style.inner">
          <div :class="$style.top">提示</div>
          <div :class="$style.bot">
            <p>
              需消耗 <span>{{ scroe }}</span> 积分，确认兑换吗？
            </p>
            <!-- 底部按钮 -->
            <div :class="$style.btn">
              <img
                :src="`${$cdnUrl}/freeKingdoms/button_cancel.png`"
                @click="$emit('closeScore')"
              />
              <img :src="`${$cdnUrl}/freeKingdoms/button_sure.png`" @click="$emit('doScore')" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DialogScore',
  props: {
    scroe: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang='scss' module>
.box {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10;
  overflow: hidden;
  .content {
    width: 300px;
    height: 267px;
    // background-color: pink;
    position: absolute;
    left: 50%;
    top: 120px;
    transform: translateX(-50%);
    > div:nth-child(1) {
      width: 282px;
      height: 100%;
      border: 1px solid #c2a67a;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
    > div:nth-child(2) {
      width: 100%;
      height: 250px;
      border: 1px solid #c2a67a;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
    .inner {
      width: 293px;
      height: 260px;
      border: 1px solid #c2a67a;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      background-color: #401f15;
      .top {
        width: 100%;
        height: 56px;
        background-color: #31170a;
        text-align: center;
        line-height: 56px;
        font-size: 23px;
        font-family: FZDaBiaoSong-B06S;
        font-weight: 400;
        color: #fff0b4;
      }
      .bot {
        width: 100%;
        height: 205px;
        position: relative;
        > p {
          width: 122px;
          font-size: 15px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #e8cf94;
          line-height: 25px;
          position: absolute;
          left: 50%;
          top: 38px;
          transform: translateX(-50%);
          text-align: center;
          > span {
            color: #24c73f;
          }
        }
        .btn {
          width: 100%;
          height: 32px;
          position: absolute;
          left: 50%;
          bottom: 38px;
          transform: translateX(-50%);
          display: flex;
          justify-content: space-between;
          padding: 0px 28px;
          > img {
            width: 111px;
          }
        }
      }
    }
  }
}
</style>